<template>
  <div class="pa-10">
    <div class="font-weight-bold">
      {{ GetPreviewUser.FirstName }} {{ GetPreviewUser.LastName }}
    </div>
    <div class="mt-6">
      <v-avatar v-if="GetPreviewUser.ProfileImage" size="150">
        <img :src="GetPreviewUser.ProfileImage" />
      </v-avatar>
      <v-avatar v-else size="150">
        <img
          src="https://www.freeiconspng.com/thumbs/profile-icon-png/profile-icon-1.png"
        />
      </v-avatar>
    </div>
    <div class="mt-6">
      {{ GetPreviewUser.Specializations }}
    </div>
    <div class="mt-6">
      <div class="font-weight-bold mb-4">Biography</div>
      <div v-html="GetPreviewUser.Bio"></div>
    </div>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
export default {
  name: "BioComponent",
  computed: {
    ...mapGetters(["GetPreviewUser"]),
  },
};
</script>
